import {createContext} from 'react';

const AnimatedStepContext = createContext();

export default AnimatedStepContext;
